import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Table, Form } from "antd";
import moment from "moment";
import CardDiv from "../../common/card-div/CardDiv";
import { Offcanvas } from "react-bootstrap";
import Filter from "../filter/Filter";
import map from "lodash/map";
import {
  buildQueryString,
  filterAndTransformParams,
} from "../../../modules/utilities/utility";
import { minutesToHoursMinutesString } from "../../../helpers/utils";

const KpiDashboard = ({
  title,
  fetchData,
  fetchFilterData,
  filterDataLoading,
  filterData,
  headers,
  totalRowCount,
  rowsData,
  loading,
}) => {
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [savedFormValues, setSavedFormValues] = useState({});
  const [triggerFetch, setTriggerFetch] = useState(true);
  const [dateRangeError, setDateRangeError] = useState(false);
  const [dateRangeErrorMessage, setDateRangeErrorMessage] = useState("");

  const getCurrentMonthDates = () => {
    const startDate = moment().format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    return [startDate, endDate];
  };
  const [queryParam, setQueryParam] = useState({
    pageSize: pageSize,
    pageNumber: currentPage,
    agentUserId: "",
    agentRmUserId: "",
    empType: "",
    callDate: getCurrentMonthDates(),
  });
  const [form] = Form.useForm();

  const handleTableChange = (pagination) => {
    const updatedPagination = {
      ...queryParam,
      pageSize: pagination.pageSize,
      pageNumber: pagination.current,
    };
    setPageSize(pagination.pageSize);
    setCurrentPage(pagination.current);
    setQueryParam(updatedPagination);
    setTriggerFetch(true);
  };

  useEffect(() => {
    if (triggerFetch) {
      const updatedFilters = filterAndTransformParams(queryParam);
      const queryString = buildQueryString(updatedFilters);
      fetchData(queryString);
      setTriggerFetch(false);
    }
  }, [triggerFetch, queryParam]);

  useEffect(() => {
    fetchFilterData();
  }, []);

  const handleApplyFilters = (filters) => {
    const mergedFilters = {
      ...queryParam,
      ...filters,
      pageSize: 10,
      pageNumber: 1,
    };
    setQueryParam(mergedFilters);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
    setVisible(!visible);
  };

  const handleFinish = (values) => {
    if (!values.callDate) {
      setDateRangeErrorMessage("Please fill Start and End Date");
      setDateRangeError(true);
      return;
    }

    const [date1, date2] = map(values.callDate, (date) =>
      date.format("YYYY-MM-DD")
    );
    const diffDays = Number(moment(date2).diff(moment(date1), "days"));

    if (diffDays > 31) {
      setDateRangeErrorMessage(
        "Difference between dates exceeds a month. Submission not allowed."
      );
      setDateRangeError(true);
      return;
    }

    const queryParam = {
      agentUserId: values.agentUserId,
      agentRmUserId: values.agentRmUserId,
      empType: values.empType,
      callDate: [date1, date2],
    };
    setSavedFormValues(values);
    handleApplyFilters(queryParam);
    setVisible(!visible);
  };

  const handleClear = () => {
    form.resetFields();
    const initialQueryParam = {
      pageSize: 10,
      pageNumber: 1,
      empType: "",
      agentUserId: "",
      agentRmUserId: "",
      callDate: getCurrentMonthDates(),
    };
    setDateRangeErrorMessage("");
    setDateRangeError(false);
    setQueryParam(initialQueryParam);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
    setSavedFormValues({});
    setVisible(!visible);
  };

  const updatedRows = rowsData.map((row) => ({
    ...row,
    totalTalkTime: minutesToHoursMinutesString(row.totalTalkTime ?? 0),
  }));

  const disabled30DaysDate = (current, { from }) => {
    if (from) {
      return Math.abs(current.diff(from, "days")) > 31;
    }
    return false;
  };

  return (
    <CardDiv
      title={title}
      component={
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <Button
              variant="primary"
              onClick={() => setVisible(true)}
              style={{ marginRight: 10 }}
            >
              Filter
            </Button>
            <Offcanvas
              show={visible}
              onHide={() => setVisible(false)}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Filter for {title}</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Filter
                  savedFormValues={savedFormValues}
                  handleClear={handleClear}
                  handleFinish={handleFinish}
                  filterData={filterData}
                  filterDataLoading={filterDataLoading}
                  disabledDaysDate={disabled30DaysDate}
                  dateRangeError={dateRangeError}
                  setDateRangeError={setDateRangeError}
                  dateRangeErrorMessage={dateRangeErrorMessage}
                  setDateRangeErrorMessage={setDateRangeErrorMessage}
                />
              </Offcanvas.Body>
            </Offcanvas>
            <span className="shadow p-2 text-nowrap text-center">
              Results: {totalRowCount}
            </span>
          </div>

          <div className="table-responsive">
            <Table
              loading={loading}
              columns={headers}
              dataSource={updatedRows}
              onChange={handleTableChange}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalRowCount,
                showSizeChanger: true,
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      }
    />
  );
};

export default KpiDashboard;
